// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.roomHeader {
  height: 4rem;
  padding: 0 1.25rem;
  background: linear-gradient(90deg, #1a3b8c, #142f79);
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  overflow: hidden;
  flex-shrink: 0;
}

/* Faint diagonal facets across the bar. */
.roomHeader::before,
.roomHeader::after {
  content: "";
  position: absolute;
  top: 0;
  bottom: 0;
  pointer-events: none;
}

.roomHeader::before {
  left: 30%;
  width: 22%;
  background: rgba(255, 255, 255, 0.05);
  transform: skewX(-24deg);
}

.roomHeader::after {
  left: 58%;
  width: 30%;
  background: rgba(0, 0, 0, 0.08);
  transform: skewX(-24deg);
}

.brand {
  display: flex;
  align-items: center;
  gap: 0.7rem;
  z-index: 1;
  color: inherit;
  text-decoration: none;
}

.galleryNav {
  z-index: 1;
  color: var(--white);
  text-decoration: none;
  font-family: var(--font-heading);
  font-weight: 600;
  font-size: 1.05rem;
  padding: 0.4rem 1.1rem;
  border-radius: var(--pill-radius);
  border: 1px solid rgba(255, 255, 255, 0.28);
  background: rgba(255, 255, 255, 0.14);
}

.galleryNav:hover,
.galleryNav:focus-visible {
  background: rgba(255, 255, 255, 0.22);
}

.headerLogo {
  height: 2.6rem;
  width: auto;
  filter: drop-shadow(0 2px 3px rgba(0, 0, 0, 0.25));
}

.headerText {
  font-family: var(--font-heading);
  font-weight: 600;
  font-size: 1.55rem;
  color: var(--white);
  letter-spacing: 0.2px;
}

.roomCodePill {
  z-index: 1;
  background: rgba(255, 255, 255, 0.14);
  border: 1px solid rgba(255, 255, 255, 0.28);
  color: var(--white);
  border-radius: var(--pill-radius);
  padding: 0.4rem 1.1rem;
  font-family: var(--font-heading);
  font-weight: 600;
  font-size: 1.05rem;
  line-height: 1.2;
  white-space: nowrap;
}

/* On phones a pink/blue accent stripe sits under the bar. */
.headerAccent {
  display: none;
  height: 6px;
  background: linear-gradient(100deg, var(--pink) 0 47%, var(--blue) 53%);
  flex-shrink: 0;
}

@media (max-width: 600px) {
  .roomHeader {
    height: 3.6rem;
    padding: 0 1rem;
  }

  .headerLogo {
    height: 2.3rem;
  }

  .headerText {
    font-size: 1.35rem;
  }

  .headerAccent {
    display: block;
  }
}
`, "",{"version":3,"sources":["webpack://./src/browser/webapp/components/header.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,kBAAkB;EAClB,oDAAoD;EACpD,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;EAChB,cAAc;AAChB;;AAEA,0CAA0C;AAC1C;;EAEE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,qCAAqC;EACrC,wBAAwB;AAC1B;;AAEA;EACE,SAAS;EACT,UAAU;EACV,+BAA+B;EAC/B,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,UAAU;EACV,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,qBAAqB;EACrB,gCAAgC;EAChC,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,iCAAiC;EACjC,2CAA2C;EAC3C,qCAAqC;AACvC;;AAEA;;EAEE,qCAAqC;AACvC;;AAEA;EACE,cAAc;EACd,WAAW;EACX,kDAAkD;AACpD;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,UAAU;EACV,qCAAqC;EACrC,2CAA2C;EAC3C,mBAAmB;EACnB,iCAAiC;EACjC,sBAAsB;EACtB,gCAAgC;EAChC,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,4DAA4D;AAC5D;EACE,aAAa;EACb,WAAW;EACX,uEAAuE;EACvE,cAAc;AAChB;;AAEA;EACE;IACE,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,cAAc;EAChB;AACF","sourcesContent":[".roomHeader {\n  height: 4rem;\n  padding: 0 1.25rem;\n  background: linear-gradient(90deg, #1a3b8c, #142f79);\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  overflow: hidden;\n  flex-shrink: 0;\n}\n\n/* Faint diagonal facets across the bar. */\n.roomHeader::before,\n.roomHeader::after {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  pointer-events: none;\n}\n\n.roomHeader::before {\n  left: 30%;\n  width: 22%;\n  background: rgba(255, 255, 255, 0.05);\n  transform: skewX(-24deg);\n}\n\n.roomHeader::after {\n  left: 58%;\n  width: 30%;\n  background: rgba(0, 0, 0, 0.08);\n  transform: skewX(-24deg);\n}\n\n.brand {\n  display: flex;\n  align-items: center;\n  gap: 0.7rem;\n  z-index: 1;\n  color: inherit;\n  text-decoration: none;\n}\n\n.galleryNav {\n  z-index: 1;\n  color: var(--white);\n  text-decoration: none;\n  font-family: var(--font-heading);\n  font-weight: 600;\n  font-size: 1.05rem;\n  padding: 0.4rem 1.1rem;\n  border-radius: var(--pill-radius);\n  border: 1px solid rgba(255, 255, 255, 0.28);\n  background: rgba(255, 255, 255, 0.14);\n}\n\n.galleryNav:hover,\n.galleryNav:focus-visible {\n  background: rgba(255, 255, 255, 0.22);\n}\n\n.headerLogo {\n  height: 2.6rem;\n  width: auto;\n  filter: drop-shadow(0 2px 3px rgba(0, 0, 0, 0.25));\n}\n\n.headerText {\n  font-family: var(--font-heading);\n  font-weight: 600;\n  font-size: 1.55rem;\n  color: var(--white);\n  letter-spacing: 0.2px;\n}\n\n.roomCodePill {\n  z-index: 1;\n  background: rgba(255, 255, 255, 0.14);\n  border: 1px solid rgba(255, 255, 255, 0.28);\n  color: var(--white);\n  border-radius: var(--pill-radius);\n  padding: 0.4rem 1.1rem;\n  font-family: var(--font-heading);\n  font-weight: 600;\n  font-size: 1.05rem;\n  line-height: 1.2;\n  white-space: nowrap;\n}\n\n/* On phones a pink/blue accent stripe sits under the bar. */\n.headerAccent {\n  display: none;\n  height: 6px;\n  background: linear-gradient(100deg, var(--pink) 0 47%, var(--blue) 53%);\n  flex-shrink: 0;\n}\n\n@media (max-width: 600px) {\n  .roomHeader {\n    height: 3.6rem;\n    padding: 0 1rem;\n  }\n\n  .headerLogo {\n    height: 2.3rem;\n  }\n\n  .headerText {\n    font-size: 1.35rem;\n  }\n\n  .headerAccent {\n    display: block;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
